module.exports = __webpack_public_path__ + "static/media/loading-icon.79c9bc2b.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/loading-icon.svg
// module id = 1543
// module chunks = 1